/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_See_AllInputs */

const en_directory_rails_see_all = /** @type {(inputs: Directory_Rails_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

const zh_directory_rails_see_all = /** @type {(inputs: Directory_Rails_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看全部`)
};

/**
* | output |
* | --- |
* | "See all" |
*
* @param {Directory_Rails_See_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_see_all = /** @type {((inputs?: Directory_Rails_See_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_See_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_see_all(inputs)
	return zh_directory_rails_see_all(inputs)
});
export { directory_rails_see_all as "directory.rails.see_all" }